import React, { useState, useEffect } from "react";
import axios from "axios";

const OptionForm = () => {
  const [form, setForm] = useState({
    title: "",
    description: "",
    logo_url: "",
    favicon_url: "",
  });

  const [logoFile, setLogoFile] = useState(null);
  const [faviconFile, setFaviconFile] = useState(null);
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/options`)
      .then(({ data }) => {
        setForm(data);
        setLoading(false);
      })
      .catch(() => {
        setStatus("Failed to load options");
        setLoading(false);
      });
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleLogoChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type === "image/png") {
      setLogoFile(file);
    } else {
      setStatus("Only PNG files are allowed for the logo.");
      e.target.value = null;
    }
  };

  const handleFaviconChange = (e) => {
    const file = e.target.files[0];
    if (file && file.name.endsWith(".ico")) {
      setFaviconFile(file);
    } else {
      setStatus("Only ICO files are allowed for the favicon.");
      e.target.value = null;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("");

    const formData = new FormData();
    formData.append("title", form.title);
    formData.append("description", form.description);

    if (logoFile) {
      formData.append("logo", logoFile);
    }

    if (faviconFile) {
      formData.append("favicon", faviconFile);
    }

    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/options/update`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      setStatus("Options updated successfully!");
      // reload to show new URLs
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/options`
      );
      setForm(data);
    } catch (err) {
      setStatus("Failed to update options.");
    }
  };

  if (loading) return <div className="text-center mt-4">Loading...</div>;

  return (
    <div className="container">
      <h3>General Settings</h3>
      {status && <div className="alert alert-info">{status}</div>}

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">Title</label>
          <input
            type="text"
            name="title"
            value={form.title}
            onChange={handleChange}
            className="form-control"
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Description</label>
          <textarea
            name="description"
            value={form.description}
            onChange={handleChange}
            className="form-control"
            rows="3"
          ></textarea>
        </div>

        <div className="mb-3">
          <label className="form-label">Current Logo</label>
          <br />
          {form.logo_url && <img src={form.logo_url} alt="Logo" height="50" />}
          <input
            type="file"
            className="form-control mt-2"
            accept="image/png"
            onChange={handleLogoChange}
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Current Favicon</label>
          <br />
          {form.favicon_url && (
            <img src={form.favicon_url} alt="Favicon" height="32" />
          )}
          <input
            type="file"
            className="form-control mt-2"
            accept=".ico"
            onChange={handleFaviconChange}
          />
        </div>

        <button className="btn btn-inchworm" type="submit">
          Save Changes
        </button>
      </form>
    </div>
  );
};

export default OptionForm;
